/**
 * @fileoverview GET handler for the "/decisioning_studio_agents/:app_group_id/:dsa_id/audiences/segments" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { decisioningStudioAgentsAppGroupIdDsaIdSegments } from "./constants";
import type { GetDecisioningStudioAgentsAppGroupIdDsaIdSegmentsResult } from "./types";
import { isGetDecisioningStudioAgentsAppGroupIdDsaIdSegmentsResult } from "./validators";

export const getDecisioningStudioAgentsAppGroupIdDsaIdSegments = reactQueryFetcherAdapter(
  decisioningStudioAgentsAppGroupIdDsaIdSegments,
  (
    signal: AbortSignal,
    appGroupId: string,
    dsaId: string
  ): Promise<GetDecisioningStudioAgentsAppGroupIdDsaIdSegmentsResult> => {
    return fetch(
      `/decisioning_studio_agents/${appGroupId}/${dsaId}/audiences/segments`,
      "GET",
      {},
      { signal },
      { propagateFetchRequestError: false }
    );
  },
  isGetDecisioningStudioAgentsAppGroupIdDsaIdSegmentsResult
);
